import type { SVGProps } from 'react';

const SvgDoorOpenOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.89 4.45-3.473.868a.99.99 0 0 0-.752.963v11.957l5.305 1.325a.13.13 0 0 0 .106-.022.13.13 0 0 0 .048-.098V5.413a.996.996 0 0 0-.787-.971 1 1 0 0 0-.446.008m2.723 1.219v12.406h2.853V6.66a.993.993 0 0 0-.992-.992zm3.6 13.894h3.471a.744.744 0 0 0 0-1.488h-2.73V6.66a2.48 2.48 0 0 0-2.48-2.481h-2.19a2.48 2.48 0 0 0-2.754-1.175l-3.474.869a2.48 2.48 0 0 0-1.88 2.407v11.794h-1.86a.744.744 0 1 0 0 1.488h2.513l5.78 1.445a1.614 1.614 0 0 0 2-1.445h3.605m-6.95-8.436c.411 0 .745.333.745.745v.007a.744.744 0 0 1-1.49 0v-.007c0-.412.334-.745.745-.745"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgDoorOpenOutlined;
